import React, { useState } from "react";
import AddNewEntry from "./AddNewEntry";

const baseTitles = [
  { title: "Today" },
  { title: "This week" },
  { title: "This month" },
  { title: "Total" },
];

const Header = ({ stats }) => {
  const [openAddNewBox, setOpenAddNewBox] = useState(false);

  const values = stats
    ? [
        stats.today || 0,
        stats.thisWeek || 0,
        stats.thisMonth || 0,
        stats.total || 0,
      ]
    : ["0", "0", "0", "0"];

  return (
    <div className="pt-4">
      <div className="px-0 sm:px-4 space-y-6">
        <div className="flex justify-between gap-2">
          <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
            Visit
          </h1>
          <div>
            <button
              className="text-white text-sm bg-primary px-3 py-2 rounded-md"
              onClick={() => setOpenAddNewBox(true)}
            >
              Add New
            </button>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-3">
          {baseTitles.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg p-3 lg:p-6 flex justify-between items-center w-full shadow-lg"
            >
              <div>
                <h2 className="text-sm font-medium text-text2 text-left lg:text-base ">
                  {item.title}
                </h2>
                <p className=" lg:text-3xl text-2xl font-bold text-text2 text-left">
                  {values[index]}
                </p>
              </div>
            </div>
          ))}
        </div>
        <hr />
      </div>
      {/* AnimatePresence ensures exit animations work */}

      {openAddNewBox && (
        <AddNewEntry closeModal={() => setOpenAddNewBox(false)} />
      )}
    </div>
  );
};

export default Header;
